import { CustomScroll } from 'react-custom-scroll';
import { SimpleNode } from '../../models/models';
import { FlexBoxFullWHColumn } from '../layout/layout.styles';
import NodeAccordion from '../node-accordion/node-accordion.component';

const NodesList = ({ nodes }: { nodes: SimpleNode[] }) => {
    return (
        <CustomScroll heightRelativeToParent="100%" className="custom-scroll">
            <FlexBoxFullWHColumn gap={2} pb={2} pr={'10px'}>
                {nodes.map((node: SimpleNode) => (
                    <NodeAccordion key={node.id} node={node} />
                ))}
            </FlexBoxFullWHColumn>
        </CustomScroll>
    );
};

export default NodesList;
